import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { textReg, addressRegex } from "../../../utils/regex";
import { Button, InputField } from "../../forms";
 import useEmployeeHook from "../../../hooks/useEmployeeHook";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import useGoalsHook from "../../../hooks/useGoalsHook";
import { ListPicker } from "../../generic/ListPicker";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import usePositionHook from "../../../hooks/usePositionHook";
const AddGoalmodal = ({ refresh, target, show }) => {
  const { selectedOrgEmployees } = useEmployeeHook();
   const positionpickHook = usePickerhook();
   const deptpickHook = usePickerhook();
     const { allorgPositions } = usePositionHook();
     const { selectedOrgDepts } = useDepartmentHook();
  const employeepickHook = usePickerhook();
  const { AddGoal } = useGoalsHook();

  const progressITems = [
    "0%",
    "10%",
    "20%",
    "30%",
    "40%",
    "50%",
    "60%",
    "70%",
    "80%",
    "90%",
    "100%",
  ];

  const [item, setitem] = useState<any>({});

  const [isedit, setiseditgoal] = useState(false);

  const [goals, setgoals] = useState([]);

  const { SelectedOrg } = useStateGetter();

  const [progress, setprogress] = useState("0%");

  const { setLoading } = useStateSetter();

  const submit = async (data: any) => {
    var pre_def = {
      ...data,
      progress: progress,
       organizationID: SelectedOrg.id,
     };

    var postdata: any;
    switch (target) {
      case "pos":
        postdata = {
          target: "position",
          positionID: positionpickHook.pickedRole.code,
          ...pre_def,
        };
        break;
      case "empl":
        postdata = {
          target: "employee",
          employeeID: employeepickHook.pickedRole.code,
          ...pre_def,
        };
        break;

      case "dept":
        postdata = {
          target: "dept",
          deptID: deptpickHook.pickedRole.code,
          ...pre_def,
        };
        break;

      default:
        postdata = {
          target: "organization",
          ...pre_def,
        };

        break;
    }
 
    setLoading(true);

    try {
      var res = await AddGoal(postdata);
    } catch (e: any) {
      toast.error(e);
    } finally {
      setLoading(false);
      refresh();
    }

    show(false);
  };

  var { control, handleSubmit, watch, setValue } = useForm();
  const watchedFields = watch(["title", "desc", "date"]);
  const areFieldsFilled = watchedFields.every(
    (field) => field !== "" && field !== undefined
  );

  const Progress = ({ item }) => {
    return (
      <div
        onClick={() => {
          setprogress(item);
        }}
        className={`px-1 py-2 text-xs cursor-pointer flex justify-center rounded-[8px]   items-center  ${
          progress == item
            ? "bg-primary text-white"
            : " border-2 border-solid border-gray-500"
        }`}
      >
        {item}
      </div>
    );
  };
  useEffect(() => {
    if (isedit) {
      setValue("title", item?.title);
      setValue("desc", item?.desc);
      setValue("date", item?.date);
    }
  }, []);
  return (
    <div className="ModalContainer shadow">
      <div className=" flex flex-col    rounded-[8px] bg-white w-[40vw] overflow-y-scroll p-4 z-20 absolute">
        <p className="font-semibold self-start text-sm ">Add Goal</p>

        <InputField
          name="title"
          title="Goal title"
          placeholder={"Enter goal title"}
          control={control}
          rules={{
            required: "title is required",
            pattern: {
              value: textReg,
              message: "Invalid title",
            },
          }}
        />
        <InputField
          name="desc"
          title="Goal description"
          placeholder={"Enter description"}
          isTextArea
          control={control}
          rules={{
            required: "description is required",
            pattern: {
              value: textReg,
              message: "Invalid description",
            },
          }}
        />

        <div className="flex p-2 overflow-x-scroll gap-1">
          {progressITems.map((it: string) => (
            <Progress item={it} />
          ))}
        </div>

        {/* target */}
        {target == "empl" && (
          <ListPicker
            fullwidth
            hook={employeepickHook}
            title="Employee"
            list={selectedOrgEmployees?.map((ik: any) => {
              return { name: ik.firstName + " " + ik.lastName, code: ik.id };
            })}
          />
        )}
        {target == "pos" && (
          <ListPicker
            fullwidth
            hook={positionpickHook}
            title="Position"
            list={allorgPositions?.map((ik: any) => {
              return { name: ik.positionTitle, code: ik.id };
            })}
          />
        )}
        {target == "dept" && (
          <ListPicker
            fullwidth
            hook={deptpickHook}
            title="Department"
            list={selectedOrgDepts?.map((ik: any) => {
              return { name: ik.deptName, code: ik.id };
            })}
          />
        )}

        <InputField
          name="date"
          title="Goal dealine"
          placeholder={"Enter deadline"}
          type={"date"}
          control={control}
          rules={{
            required: "deadline is required",
            pattern: {
              value: addressRegex,
              message: "Invalid deadline",
            },
          }}
        />

        <div className=" flex justify-center items-center w-full gap-6">
          <Button
            outlined
            text="Cancel"
            onBtnClick={() => {
              show(false);
            }}
          />

          <Button
            disabled={!areFieldsFilled}
            text={!isedit ? "Add Goal" : "Save"}
            onBtnClick={handleSubmit(submit)}
          />
        </div>
      </div>
    </div>
  );
};

export { AddGoalmodal };
